import React, { Component } from "react";
import styled from "styled-components";
import { DndTable } from '@loanbossinc/component-library';

const StyledNullContainer = styled.div`&& {
  /* Fill / White */

  background: #FFFFFF;
  /* Stroke / Gray */
  
  border: 1px solid #DADCE0;
  box-sizing: border-box;
  border-radius: 0px;
  height:63px;
}`;

const StyledNullMessage = styled.div`&& {
  /* Work Sans / 14 Regular */

  font-family: Work Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  align-items: flex-end;
  margin-top: 25px;
  margin-left: 24px;

  /* Text / Dark Gray */  
  color: #5F6368;  
}`;
export class DnDQuoteTable extends Component {
  

  mapData = () => {
    const { data } = this.props;
    const mapped = data.map(item => ({
      ...item
      , lender: {
        name: item && item['loanProvider.name']
        , loanType: item && item['loanType.name']
      }
      , ltvAndAmount: {
        amount: item && item['amount']
        , ltv: item && item['covenants.ltvStabilized']
      }
    }));
    return mapped;
  }

  render() {
    const { data, selectedQuote, history, deal, saveOrderChange, noDataMessage, columns, onRowClick} = this.props;

    if (!data || !data.length) 
    return (
      <StyledNullContainer>
        <StyledNullMessage>
          {noDataMessage}
        </StyledNullMessage>
      </StyledNullContainer>
    );

    return (
      <DndTable
        columns={columns}
        onRowClick={onRowClick}
        saveOrderChange={(items)=>saveOrderChange({quotes: items, dealId: deal.id})}
        items={this.mapData()}
        selectedItem={selectedQuote}
      />
    );
  }
}
